import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { Button } from '/imports/ui/Button';
import { Input } from '/imports/ui/Input';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { sendPasswordResetLink } from '/imports/api/users';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';

export const ForgotPasswordPage = () => {
  const [identifier, setIdentifier] = useState('');
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await sendPasswordResetLink.call(identifier);
      toast.success(strings.PleaseCheckYourEmailAndOrSmsForPasswordResetLink());
    }
    catch (error: any) {
      if (error?.error === 'multipleUsersFound') {
        toast.error(strings.AnErrorOccurredPleaseTryAgainOrContactSupport());
      }
    }
  };
  return (
    <SignedOutPageStyled className="page">
      <div className="wrapper">
        <div className="inner-wrapper">
          <div><Logo size={2} /></div>
          <div>
            <h2>{strings.ForgotPassword()}</h2>
            <div>{strings.ForgotPasswordInstructions()}</div>
          </div>
          <form onSubmit={onSubmit}>
            <div className="inputs">
              <Input placeholder={strings.Email()} value={identifier} inputId="email-input"
                onChange={(identifier) => setIdentifier(identifier || '')} autoFocus />
            </div>
            <Button id="reset-submit" type="submit" disabled={!identifier}><div>{strings.SendResetLink()}</div></Button>
            <div className="login-error"></div>
          </form>
          <Link className="forgot-password" to='/login'>{strings.BackToLogin()}</Link>
        </div>
      </div>
      <PublicFooter />
    </SignedOutPageStyled>
  );
};